module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-array-edit"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "input-group-button"
  }, [_c('button', {
    staticClass: "button fa fa-plus",
    attrs: {
      "disabled": !_vm.newName
    },
    on: {
      "click": _vm.addField
    }
  })])]), (_vm.options !== null) ? _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    staticClass: "input-group-field",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.options), function(groups) {
    return _vm._l((groups), function(group, groupName) {
      return _c('optgroup', {
        key: groupName,
        attrs: {
          "label": groupName
        }
      }, [_vm._l((group), function(options) {
        return _vm._l((options), function(item, key) {
          return _c('option', {
            domProps: {
              "value": key
            }
          }, [_vm._v(_vm._s(item))])
        })
      })], 2)
    })
  })], 2), _c('div', {
    staticClass: "input-group-button"
  }, [_c('button', {
    staticClass: "button fa fa-plus",
    attrs: {
      "disabled": !_vm.newName
    },
    on: {
      "click": _vm.addField
    }
  })])]) : _vm._e(), _vm._l((_vm.values), function(value, label) {
    return (typeof value !== 'undefined') ? _c('div', {
      staticClass: "prop-item"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-label"
    }, [_vm._v(_vm._s(label))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[label]),
        expression: "values[label]"
      }],
      staticClass: "input-group-field",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.values[label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.values, label, $event.target.value)
        }
      }
    }), _c('div', {
      staticClass: "input-group-button"
    }, [_c('button', {
      staticClass: "button warning fa fa-times",
      on: {
        "click": function($event) {
          return _vm.removeField(label)
        }
      }
    })])])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a733f42e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/ArrayEdit.vue
// module id = 2489
// module chunks = 1